import { AllocationType } from '@carvia/ros-client-types';

export type TransferBar = {
  id: string;
  lineId: string;
  tag?: string;
  transferOfId?: string | null;
  xStartPosInDays: number | null;
  xEndPosIndDays: number | null;
  roundLeft: boolean;
  roundRight: boolean;
  textPadLeftDays: number;
  textPadRightDays: number;
};

export const TRANSFER_JOIN_RADIUS_PX = 2;

const isTransferTag = (tag?: string) =>
  tag === AllocationType.TRANSFER_DELIVERY || tag === AllocationType.TRANSFER_RETURN;

const overlapDays = (
  start: number | null,
  end: number | null,
  radiusPx: number,
  pxPerDay: number,
) => {
  if (start === null || end === null || pxPerDay <= 0) return 0;
  const widthPx = Math.max(0, (end - start) * pxPerDay);
  return Math.min(radiusPx, Math.max(0, widthPx - radiusPx)) / pxPerDay;
};

/** Square the join and tuck the parent under a linked transfer by about one corner radius. */
export const connectTransferBars = (
  blocks: TransferBar[],
  { radiusPx, pxPerDay }: { radiusPx: number; pxPerDay: number },
): void => {
  const byId = new Map(blocks.map((block) => [block.id, block]));

  for (const block of blocks) {
    if (!isTransferTag(block.tag) || !block.transferOfId) continue;
    const parent = byId.get(block.transferOfId);
    if (!parent || parent.lineId !== block.lineId) continue;

    const tuck = overlapDays(block.xStartPosInDays, block.xEndPosIndDays, radiusPx, pxPerDay);

    if (block.tag === AllocationType.TRANSFER_DELIVERY) {
      block.roundRight = false;
      parent.roundLeft = false;
      if (block.xEndPosIndDays !== null) {
        parent.xStartPosInDays = block.xEndPosIndDays - tuck;
      }
      parent.textPadLeftDays = tuck;
      continue;
    }

    block.roundLeft = false;
    parent.roundRight = false;
    if (block.xStartPosInDays !== null) {
      parent.xEndPosIndDays = block.xStartPosInDays + tuck;
    }
    parent.textPadRightDays = tuck;
  }
};
